interface DateRange {
  minutes: number;
  hours: number;
  days: number;
  months: number;
  years: number;
}

/**
 * * Расчет диапазона между двумя датами а различных величинах
 * @param startDate Дата старта
 * @param endDate Конечная дата
 * @returns
 */
export const calculateDateRange = (
  startDate: Date,
  endDate: Date
): DateRange => {
  const differenceInMilliseconds = endDate.getTime() - startDate.getTime();

  const minutes = Math.floor(differenceInMilliseconds / (1000 * 60));
  const hours = Math.floor(differenceInMilliseconds / (1000 * 60 * 60));
  const days = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));

  // Для расчета месяцев и лет используем прямое сравнение дат
  let years = endDate.getFullYear() - startDate.getFullYear();
  let months = endDate.getMonth() - startDate.getMonth();

  // Если месяц endDate меньше месяца startDate, уменьшаем год и добавляем 12 месяцев
  if (months < 0) {
    years -= 1;
    months += 12;
  }

  // Если день endDate меньше дня startDate, уменьшаем месяц и пересчитываем разницу в днях
  let exactMonths = months;
  if (endDate.getDate() < startDate.getDate()) {
    exactMonths -= 1;
  }

  return {
    minutes,
    hours,
    days,
    months: years * 12 + exactMonths, // Общая разница в месяцах
    years,
  };
};
